import {
  booking_status,
  payment_status,
} from "@/modules/checkin-facility/utils/mockup";
import _, { times } from "lodash";
import moment from "moment-timezone";
import t from "typy";
import { mapActions, mapGetters, mapState } from "vuex";
import LanguageButtonComponent from "../../dashboard/components/language-button.component";
import CheckoutDetails from "../components/checkout/CheckoutDetails.vue";
import GatewayPayment from "../components/gatewayPayment.vue";
import LeaveWarningModal from "../components/LeaveWarningModal.vue";
import CheckoutGuideComponent from "./../../../components/checkout-guide.component";
import TermsComponent from "./../../../components/terms.component";

export default {
  components: {
    TermsComponent,
    CheckoutGuideComponent,
    LanguageButtonComponent,
    CheckoutDetails,
    GatewayPayment,
    LeaveWarningModal
  },
  data() {
    return {
      hideButton: false,
      typy: t,
      submit_btn: "",
      error_msg: "",
      success_msg: "",
      confirm: false,
      facility: {
        name: "...",
      },
      user: {
        email: "",
        key: "",
      },
      form_language: "",
      enabled_languages: [],
      is_custom: false,
      custom_text_setting: {},
      step: "prematch",
      paid_statuses: [
        payment_status.pay_at_reception,
        payment_status.paid_authorized,
        payment_status.paid_captured,
        payment_status.paid,
      ],
      paid: true,
      currency: "",
      invalid_code_error: [],
      is_loading: true,
      checkout_is_loading: false,
      navigationConfirmed: false,
      formIsDirty: false,
      isCheckoutNotAvailable: false,
      errorCheckoutTimingNotAvailable: "",
      reservation_no: "",
      mealDetails: {},
    };
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  async mounted() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    this.facility = await this.$lionheart
      .post("/facility/list", { slug_name: this.$route.params.slug_name })
      .then((r) => this.catcher(r.data, "data[0].id", (r) => r.data[0]))
      .catch((e) => this.catcher(e));
    if (this.facility.error.has_error) return this.$router.push("/404");

    const el = await this.$lionheart.post("/facility-setting/list", {
      facility_id: this.facility.id,
      name: "language",
      paginate: false,
    });

    if (el.data.total != 0)
      el.data.data[0].value.forEach((value, key) => {
        this.enabled_languages.push(value.code);
      });
    else this.enabled_languages.push("en", "ja");

    const pms_settings = await this.$lionheart.post("/facility-setting/list", {
      facility_id: this.facility.id,
      name: "pms_settings",
      paginate: false,
    });

    if (pms_settings.data.total != 0)
      this.facility.pms_code = pms_settings.data.data[0].value.pms_code;
    else return this.$router.push("/404");

    //  timing setting
    this.checkCheckouTimingSettings();

    this.is_custom = this.facility.facility_setting.length > 0 ? true : false;

    this.loadCustomTextSetting(this.$i18n.locale, this.facility.id);
    this.is_loading = false
    // Auto confirm
    if (this.$route.query.e && this.$route.query.k) {
      this.is_loading = true
      this.user.email = this.$route.query.e
      this.user.key = this.$route.query.k

      setTimeout(() => this.submit('confirm'), 500);
    }

  },
  computed: {
    ...mapGetters("checkin-site", ["booking"]),
    ...mapState("guest", ["isCheckoutFormEmpty"])
  },

  methods: {
    ...mapActions("checkin-site", ["setBooking"]),
    ...mapActions("guest", ["setCheckoutFormEmpty"]),

    async fetchMealDetails(rsvNo, facilityId, pass) {
      const payload = { reservation_no: rsvNo, facility_id: facilityId, pass: pass };

      try {
        const response = await this.$lionheart.get('/meal-reservation/meal', {
          params: payload
        });
        this.mealDetails = response.data;
      } catch (error) {
        console.error("Error fetching meal data:", error);
      }
    },

    confirmLeave() {
      this.redirectBack();
      this.$bvModal.hide('leave-warning-modal')
    },

    stayOnPage() {
      this.$bvModal.hide('leave-warning-modal')
    },

    markChanges() {
      this.formIsDirty = true;
    },

    handleBeforeUnload(event) {
      if (this.formIsDirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    },

    submit(action) {
      this.submit_btn = action;
      setTimeout(() => this.$refs.checkoutForm.click(), 500);
    },

    async submitForm(e) {
      e.preventDefault();
      this.error_msg = "";
      this.success_msg = "";
      this.formIsDirty = false;

      if (this.submit_btn == "confirm") {
        if (this.step == "prematch") return this.confirmation();
        if (this.step == "match") return this.paymentConfirmation();
      }

      if (this.submit_btn == "close") {
        this.step = "prematch";
        this.confirm = false;
        return;
      }
    },

    async confirmation() {
      const user = this.user;
      const data = {
        facility_id: this.facility.id,
        pass: user.key,
        email: user.email,
        mode: "pre-checkin", // THIS MODE CAN BE CHANGED
        intentMode: "checkout"
      }

      // FIRST, THE REQUEST WILL SEARCH THE EMAIL IN THE facility_visitor_logs
      // CHANGE THE MODE TO PRE-CHECKIN
      data.mode = "pre-checkin";
      let response = await this.$lionheart
        .post("/v2/facility-booking/list", data)
        .catch((e) => this.catcher(e));

      let booking = response.data

      // get the pms reservation no in the booking for MRS
      this.reservation_no = booking.data[0]?.pms_reservation_no ?? "";


      // IF THE RESULT IS NOT FOUND, THEN SEND A REQUEST TO SEARCH TO THE METADATA
      // CHANGE THE MODE TO BY-EMAIL-PASS
      if (booking.data.length == 0) {
        data.mode = "by-pass-email-with-formlog";
        response = await this.$lionheart
          .post("/v2/facility-booking/list", data)
          .catch((e) => this.catcher(e));

        booking = response.data;

        // SET THE EMAIL ADDRESS RETRIEVED INSIDE WHEN DATE MODE IS BY-PASS-EMAIL-WITH-FORMLOG
        if (booking.data.length > 0) {
          this.user.email = booking.data[0].facility_visitor_log['visitor']['user']['email'] ?? '';
        }
      }

      // THROW AN ERROR IF THE RESULT IS STILL NOT FOUND
      if (booking.data.length == 0) {
        this.is_loading = false
        this.invalid_code_error.push(
          "We could not find a reservation with this email and pass. Please try again"
        );
        setTimeout(() => {
          this.invalid_code_error.shift();
        }, 5000);
        return;
      }

      if (booking.data[0].payment_metadata) {
        this.currency = booking.data[0].payment_metadata.hasOwnProperty("currency")
          ? booking.data[0].payment_metadata.currency
          : "JPY";
      }

      if (!booking.success) return this.errorDisplay(booking.message);
      if (
        booking.data.length == 0 ||
        booking.data[0].booking_status_id != booking_status.checked_in
      )
        return this.errorDisplay(
          this.$t("visit-information-form.no_reservation_msg")
        );

      this.setBooking(booking);

      if (booking.data[0].payment_metadata == null) return this.checkout(false);

      if (this.isPaid()) {
        return (this.step = "confirmation");
      }

      this.step = "match";
    },

    async paymentConfirmation() {
      const status = await this.$refs.gatewayPayment.doCall().createPaymentMethod();
      if (status) {
        this.confirm = true;
        this.step = "confirmation";
        window.scrollTo(0, 10);
      }
    },

    async checkout(doPayment = true) {
      const data = {
        key: this.user.key,
        email: this.user.email,
        pms_code: this.facility.pms_code,
        timezone: moment.tz.guess(),
        facility_id: this.facility.id // added to fixed qr switch issue
      };

      // this.hideButton = true;
      if (doPayment) {
        const payment = await this.$refs.gatewayPayment.doCall().makePayment(true);
        if (!payment) {
          this.confirm = false;
          setTimeout(() => this.$refs.gatewayPayment.doCall().reInit(), 300);
          return;
        }
      }

      // meal details fetch
      this.fetchMealDetails(this.reservation_no, this.facility.id, this.user.key);

      const checkout = await this.$lionheart
        .post("/facility-key/g/checkout", data)
        .then((r) => this.catcher(r.data, "data.id", (r) => r.data))
        .catch((e) => this.catcher(e));

      if (checkout.error.has_error) {
        // NO RESULT FOUND, THEN DISPLAY ERROR
        this.confirm = false;
        return this.errorDisplay(checkout.error.msg);

      } else {
        // MEANS RESULT HAS DATA
        // CLEAR VARIABLE

        //start update the MRS reservation status
        if (this.mealDetails.hasMealData) {
          
          const payload = {
            "reservation_no": this.reservation_no,
            "status": "completed",
            "pass": this.user.key,
            "pms_code": this.facility.pms_code
          }

          const mrsUpdate = await this.$mrsApi.patch(`/reservations/update-status`, payload)
            .then((r) => this.catcher(r.data, null, (r) => r))
            .catch((e) => this.catcher(e));

          if (mrsUpdate.error.has_error) {
            this.confirm = false;
            return this.errorDisplay(mrsUpdate.error.msg);
          } else {
            this.completeCheckout();
          }
        }

        this.completeCheckout();
      }
    },
    completeCheckout() {
      this.user.key = "";
      this.user.email = "";
      this.confirm = null;
      this.step = "done";
      this.setBooking({});
    },
    async back() {
      const formEmpty = await this.isCheckoutFormEmpty;

      if (formEmpty === false) {
        this.$bvModal.show('leave-warning-modal');
      } else {
        this.redirectBack();
      }
    },

    redirectBack() {
      if (this.step == "match") {
        this.step = "prematch";
        this.confirm = false;
        this.setBooking({});
      }

      if (this.step == "confirmation") {
        if (this.paid) {
          this.step = "prematch";
        } else {
          this.step = "match";
          setTimeout(() => this.$refs.gatewayPayment.doCall().reInit(), 300);
        }

        window.scrollTo(0, 10);
        this.confirm = true; // permanent disabled the payment if error occurs
      }
    },

    isPaid(showPayment) {
      if (showPayment == 0) {
        this.step = "confirmation";
        return (this.paid = true);
      }

      // Show the form again if not yet paid
      this.is_loading = false
      return (this.paid = this.paid_statuses.includes(
        this.booking.data[0].payment_status_id
      ));
    },

    errorDisplay(d) {
      this.is_loading = false;
      this.error_msg = d;
      return;
    },

    successDisplay(d) {
      this.success_msg = d;
      return;
    },

    async reloadQuestion(lang) {
      this.form_language = lang;
      this.$i18n.locale = lang;
      this.confirm = false;
      this.loadCustomTextSetting(lang, this.facility.id);
    },
    async loadCustomTextSetting(lang, id) {
      let params;

      if (this.is_custom) {
        params = {
          name: `message-checkout-form-${lang}`,
          fallback: "message-checkout-form-en",
        };
      } else {
        params = {
          name: `message-checkout-form-${lang}`,
          fallback: "message-checkout-form-en",
        };
      }

      const response = await this.$lionheart.get("/custom-messages/" + id, {
        params: params,
      });
      this.custom_text_setting = response.data.data.value;
    },

    async checkCheckouTimingSettings() {
      const timezonSetting = await this.$lionheart.get("v2/facility-settings", {
        params: {
          facility_id: this.facility.id,
          name: "timezone",
          paginate: 0
        }
      });
      const timezone = timezonSetting.data.data.length > 0 ? timezonSetting.data.data[0].value : "Asia/Tokyo";
      const checkoutTimingSettings = await this.$lionheart.get("v2/facility-settings", {
        params: {
          facility_id: this.facility.id,
          name: "checkout_timing_settings",
          paginate: 0
        }
      });
      const timing = checkoutTimingSettings.data.data.length > 0 ? checkoutTimingSettings.data.data[0].value : { from: "00:00", to: "23:59" };

      const checkoutFromTimingSetting = timing.from;
      const checkoutToTimingSetting = timing.to;

      const facilityCurrenTimeZone = moment.tz(timezone);
      const facilityTimeOnly = moment(facilityCurrenTimeZone.format("HH:mm"), "HH:mm");
      const fromCheckoutTiming = moment(checkoutFromTimingSetting, "HH:mm") ?? null;
      const toCheckoutTiming = moment(checkoutToTimingSetting, "HH:mm") ?? null;

      const isCheckoutTimingInRange = facilityTimeOnly.isBetween(fromCheckoutTiming, toCheckoutTiming, undefined, '[]');
      const fromTime = fromCheckoutTiming.format("HH:mm");
      const toTime = toCheckoutTiming.format("HH:mm");
      const errorMessage = this.$t("visitor-checkout-form.error_checkout_not_available_note", { fromTime: fromTime, toTime: toTime })
      this.errorCheckoutTimingNotAvailable = errorMessage;
      this.isCheckoutNotAvailable = true;
      if (isCheckoutTimingInRange === true) {
        this.errorCheckoutTimingNotAvailable = "";
        this.isCheckoutNotAvailable = false;
      }

    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.formIsDirty) {
      // Wait for the user to confirm or cancel
      this.$once('confirm', () => {
        this.formIsDirty = false;
        next(); // Proceed with navigation
      });
      this.$once('cancel', () => {
        next(false); // Cancel navigation
      });
    } else {
      next(); // Proceed with navigation
    }
  },
  watch: {
    isCheckoutFormEmpty(val) {
      if (val === undefined) {
        this.setCheckoutFormEmpty(true);
      } else {
        this.setCheckoutFormEmpty(val);
      }
    },
  }
};
